import { z } from 'zod'

/**
 * What a client did on their shared proposal.
 *
 * Mirrors the `ProposalActivityKind` enum in api/prisma/schema.prisma.
 *
 * Kept to what helps a salesperson make the next call: what was read and for
 * how long, which plans were tried, a budget typed, which trees were opened,
 * whether it was printed, shared or put on a screen for a meeting. Nothing
 * about the reader beyond what the delivery already records.
 */
export const PROPOSAL_ACTIVITY_KINDS = [
  'OPENED',
  'READ',
  'TREE',
  'PLAN',
  'BUDGET',
  'ADJUSTED',
  'VIDEO',
  'PRINTED',
  'SHARED',
  'PRESENTED',
] as const

export const proposalActivityKindSchema = z.enum(PROPOSAL_ACTIVITY_KINDS)

export type ProposalActivityKind = z.infer<typeof proposalActivityKindSchema>
